module.exports = __webpack_public_path__ + "img/small-7.e1d844c1.jpg";